import React from "react";
import ScrollAnimation from "react-animate-on-scroll";
import { Button, Form, Container, Nav, Row, Tab, Col, Dropdown, Breadcrumb } from "react-bootstrap";
import Select from 'react-select';
import $ from "jquery"
import qs from "qs"
import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
// import BreadcrumbPage from "../Components/SearchResult/BreadcrumbPage/BreadcrumbPage";
import NewTabSearch from "../Components/SearchResult/TabSearchResult/NewTabSearch";
import IncludeSold from '../Components/SearchResult/filterSold'
import IncludeLet from '../Components/SearchResult/filterLet'
import SeoResults, { ACTION_TYPES, ACTION_DESC_TYPES, getPriceStr } from "../Components/SearchResult/seoResults"
import { parseSearchUrl, propertyH1 } from "../Components/SearchResult/utils";
import { navigate } from "@reach/router"
import algoliasearch from "algoliasearch/lite"

import {
  connectStats,
  SortBy,
  connectInfiniteHits,
  connectToggleRefinement,
  InstantSearch,
  RefinementList,
  connectSearchBox,
  connectMenu,
  connectRange,
  Configure,
  ToggleRefinement,
  connectSortBy,
  Menu,
  connectAutoComplete
} from "react-instantsearch-dom"
import Cookies from 'universal-cookie'
import { Link } from "@StarberryUtils"
import ImgMain1 from "../images/SearchResult/img-main-1.jpg";
import List1GridImg1 from "../images/SearchResult/list1grid-img1.jpg";
import List1GridImg2 from "../images/SearchResult/list1grid-img2.jpg";
import List1GridImg3 from "../images/SearchResult/list1grid-img3.jpg";
import UserImg1 from "../images/SearchResult/user.jpg";
import { UserObjectStoreProvider, isAuthenticated, useUserObjectState, useAuthState, SaveItem, savedSearchParams, getUserobjectData } from "@starberry/myaccount-website-utils"

const mycookies = new Cookies();
const updateAfter = 500

var minpricevalsales = minpricevalsales || ""
var maxpricevalsales = maxpricevalsales || ""
var minpricevalrentals = minpricevalrentals || ""
var maxpricevalrentals = maxpricevalrentals || ""

const searchClient = algoliasearch(
  `${process.env.GATSBY_ALGOLIA_APP_ID}`,
  `${process.env.GATSBY_ALGOLIA_SEARCH_KEY}`
)

const index_name = `${process.env.GATSBY_ALGOLIA_INDEX_NAME}`


// Property results loop
const InfiniteHits = ({
  hits,
  hasPrevious,
  refinePrevious,
  hasMore,
  refineNext,
  location,
  userObjects
}) => (
  <>
    {(hits.length > 0 && hasPrevious) && (
      <button
        id="myprevbut"
        onClick={refinePrevious}
        disabled={!hasPrevious}
        className="d-none"
      >
        Show prev
      </button>
    )}

    {
      hits.map((hit, i) => {

        // property details url structure
        let uriStr = "";
        let mysale = "";

        if (hit.searchType === "sales" && hit.department === 'residential') {
          uriStr = `property-for-sale/`
          mysale = `myResSaleProp`
        }
        else if (hit.searchType === "lettings" && hit.department === 'residential') {
          uriStr = `property-to-rent/`
          mysale = `myResRentProp`
        }
        // property details url structure

        //property description
        let text_truncate = function (str, length, ending) {
          // 
          var $win = $(window);

          if ($win.width() <= 1500) {
            if (length == null) {
              length = 100;
            }
          } else if ($win.width() >= 1500) {
            if (length == null) {
              length = 200;
            }
          }
          // 

          if (ending == null) {
            ending = '...';
          }
          if (str.length > length) {
            return str.substring(0, length - ending.length) + ending;
          } else {
            return str;
          }
        };
        // property description

        return (
          <>
            <NewTabSearch
              objectID={hit.objectID}
              images={[hit.images1, hit.images2]}
              studentProperty={hit.studentProperty}
              officeId={hit.office_crm_id}
              status={hit.status}
              searchType={hit.searchType}
              ImgGalleryNumber={'1/' + ((hit.images1?.length || 0) + (hit.images2?.length || 0))}
              ListImageGrid1={hit.images2 && hit.images2[0]}
              ListImageGrid2={hit.images2 && hit.images2[1]}
              ListImageGrid3={hit.images2 && hit.images2[2]}
              ItemPrice={hit.price && hit.price.toLocaleString()}
              ItemGuideText={hit.price_qualifier}
              ItemAddress={hit.display_address && hit.display_address}
              ItemSmallDescription={hit.title && hit.title}
              ItemDetailDescription={hit.description ? text_truncate(hit.description) : ''}
              UserImage1={UserImg1}
              negotiator_details={hit.negotiator_details}
              ContactNumber={ hit.negotiator_details && hit.negotiator_details.telephone
                ? hit.negotiator_details.telephone
                : hit.negotiator_details && hit?.negotiator_details?.Mobile?.value }
              Email={hit.negotiator_details &&  hit.negotiator_details.email
                ? hit?.negotiator_details?.email
                : hit.negotiator_details && hit?.negotiator_details?.Email?.value}
              Name={hit.negotiator_details && hit.negotiator_details.name
                ? hit.negotiator_details.name
                : hit.negotiator_details && hit?.negotiator_details?.Name?.value}
              PropertyDetailsUrl={`/${uriStr}${hit.slug}-${hit.objectID}`}
              FloorplanImg={hit.floorplan && hit.floorplan}
              // unkey={uuidv4()}
              videoid={hit.virtual_tour && hit.virtual_tour}
              userObjects={userObjects}
            />
          </>
        )
      })}

    <Container>
      <Row>
        <Col lg={12} className="mb-4">
          {(hits.length > 0 && hasMore) && (
            <Button
              id="mynextbut"
              onClick={refineNext}
              disabled={!hasMore}
              variant="outline" className="btn btn-view m-auto"

            >
              Load more
            </Button>
          )}
        </Col>
      </Row>
    </Container>
  </>
)

const CustomInfiniteHits = connectInfiniteHits(InfiniteHits)
// Property results loop

// Searchbox
const SearchBox = connectSearchBox(({ currentRefinement, refine }) => {
  return (
    <div className="filter-search-input-box">
      <div className="dropdown">
        <i className="icon-location-input"></i>
        <Form.Control type="search" placeholder="Street, area or postcode" id="formBasicEmail"
          onChange={event => refine(event.currentTarget.value.replace(/ /g, "-"))}
          value={currentRefinement.replace(/-/g, ' ')}
        />
      </div>
    </div>
  )
})
// Searchbox

// Dropdown custom styles
const customStyles = {
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#1E1E1F" : null,
      color: isSelected ? "#ffffff" : "#1E1E1F"
    };
  },
  control: styles => ({
    ...styles,
    backgroundColor: null,
    border: 0,
    outline: 0,
    boxShadow: 'none',
    color: '#1E1E1F',
    fontSize: '1.125rem',
    fontWeight: '400',
    padding: '10',
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: '#1E1E1F',
    }
  },
  valueContainer: (styles) => ({
    ...styles,
    fontSize: '1.125rem',
    fontWeight: '400',
    padding: 10,
  }),
  indicatorSeparator: () => null,
}

const customStylesPrice = {
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isFocused ? "#1E1E1F" : null,
      color: isFocused ? "#ffffff" : "#1E1E1F"
    };
  },
  control: styles => ({
    ...styles,
    backgroundColor: null,
    border: 0,
    outline: 0,
    boxShadow: 'none',
    color: '#1E1E1F',
    fontSize: '1.125rem',
    fontWeight: '400',
    padding: '10',
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: '#1E1E1F',
    }
  },
  valueContainer: (styles) => ({
    ...styles,
    fontSize: '1.125rem',
    fontWeight: '400',
    padding: 10,
  }),
  indicatorSeparator: () => null,
}
// Dropdown custom styles

// Property Sale Min Price
const priceminRangeSales = [
  {
    value: "0",
    label: "No Min"
  },
  {
    value: "100000",
    label: "£100,000"
  },
  {
    value: "200000",
    label: "£200,000"
  },
  {
    value: "300000",
    label: "£300,000"
  },
  {
    value: "400000",
    label: "£400,000"
  },
  {
    value: "500000",
    label: "£500,000"
  },
  {
    value: "600000",
    label: "£600,000"
  },
  {
    value: "700000",
    label: "£700,000"
  },
  {
    value: "800000",
    label: "£800,000"
  },
  {
    value: "900000",
    label: "£900,000"
  },
  {
    value: "1000000",
    label: "£1,000,000"
  },
  {
    value: "1100000",
    label: "£1,100,000"
  },
  {
    value: "1200000",
    label: "£1,200,000"
  },
  {
    value: "1300000",
    label: "£1,300,000"
  },
  {
    value: "1400000",
    label: "£1,400,000"
  },
  {
    value: "1500000",
    label: "£1,500,000"
  },
  {
    value: "1600000",
    label: "£1,600,000"
  },
  {
    value: "1700000",
    label: "£1,700,000"
  },
  {
    value: "1800000",
    label: "£1,800,000"
  },
  {
    value: "1900000",
    label: "£1,900,000"
  },
  {
    value: "2000000",
    label: "£2,000,000"
  },
  {
    value: "2500000",
    label: "£2,500,000"
  },
  {
    value: "3000000",
    label: "£3,000,000"
  }
]

const minpriceSelectBoxSales = ({
  currentRefinement,
  min,
  max,
  precision,
  refine,
}) => {
  let minPriceRangeSales = priceminRangeSales;
  if (currentRefinement.max !== undefined && currentRefinement.max != "0") {
    minPriceRangeSales = priceminRangeSales.filter((x) => parseInt(x.value) < parseInt(currentRefinement.max))
  }

  return (
    <div className="select-group">
      <Select
        name="price"
        options={minPriceRangeSales}
        defaultValue={currentRefinement.min || "0"}
        placeholder={currentRefinement.min === undefined || null || 0 ? "Min Price" : "£" + currentRefinement.min.toLocaleString()}
        classNamePrefix={"select-opt"}
        isSearchable={false}
        // onChange={(e) => {
        //     minpricevalsales = e.value
        //     if (e.value === "0") {
        //         if (maxpricevalsales) {
        //             refine({
        //                 max: maxpricevalsales,
        //             })
        //         } else refine(e.value, e.label)
        //     } else {
        //         refine({
        //             min: e.value,
        //             max: maxpricevalsales,
        //         })
        //     }
        // }}
        onChange={(e) => {
          minpricevalsales = e.value
          if (e.value === "0") {
            if (maxpricevalsales !== "0") {
              refine({
                max: maxpricevalsales,
              })
            } else refine(e.value, e.label)
          } else {
            if (maxpricevalsales == "0") {
              refine({
                min: e.value,
                // max: maxpricevalsales,
              })
            } else {
              refine({
                min: e.value,
                max: maxpricevalsales,
              })
            }
          }
        }}
        styles={customStylesPrice}
        components={{ IndicatorSeparator: () => null }}
      />
    </div>
  )
}

const CustomminpriceSelectboxSales = connectRange(minpriceSelectBoxSales)
// Property Sale Min Price

// Property Sale Max Price
const pricemaxRangeSales = [
  {
    value: "0",
    label: "No Max"
  },
  {
    value: "3000000",
    label: "£3,000,000 +"
  },
  {
    value: "2500000",
    label: "£2,500,000"
  },
  {
    value: "2000000",
    label: "£2,000,000"
  },
  {
    value: "1900000",
    label: "£1,900,000"
  },
  {
    value: "1800000",
    label: "£1,800,000"
  },
  {
    value: "1700000",
    label: "£1,700,000"
  },
  {
    value: "1600000",
    label: "£1,600,000"
  },
  {
    value: "1500000",
    label: "£1,500,000"
  },
  {
    value: "1400000",
    label: "£1,400,000"
  },
  {
    value: "1300000",
    label: "£1,300,000"
  },
  {
    value: "1200000",
    label: "£1,200,000"
  },
  {
    value: "1100000",
    label: "£1,100,000"
  },
  {
    value: "1000000",
    label: "£1,000,000"
  },
  {
    value: "900000",
    label: "£900,000"
  },
  {
    value: "800000",
    label: "£800,000"
  },
  {
    value: "700000",
    label: "£700,000"
  },
  {
    value: "600000",
    label: "£600,000"
  },
  {
    value: "500000",
    label: "£500,000"
  },
  {
    value: "400000",
    label: "£400,000"
  },
  {
    value: "300000",
    label: "£300,000"
  },
  {
    value: "200000",
    label: "£200,000"
  },
  {
    value: "100000",
    label: "£100,000"
  }
]

const maxpriceSelectBoxSales = ({
  currentRefinement,
  min,
  max,
  precision,
  refine,
}) => {

  let maxPriceRangeSales = pricemaxRangeSales;
  let maxpricedisablesales = ''
  if (currentRefinement.min !== undefined) {
    maxPriceRangeSales = pricemaxRangeSales.filter(x => x.value == "0" || parseInt(x.value) > parseInt(currentRefinement.min))
  }
  if (currentRefinement.min == "10000000") {
    maxpricedisablesales = "disabled"
  }

  return (
    <div className="select-group">
      <Select
        name="price"
        options={maxPriceRangeSales}
        defaultValue={currentRefinement.max || "0"}
        placeholder={currentRefinement.max === undefined || null || 0 ? "Max Price" : "£" + currentRefinement.max.toLocaleString()}
        classNamePrefix={"select-opt"}
        isSearchable={false}
        onChange={(e) => {
          maxpricevalsales = e.value
          if (e.value === "0") {
            if (minpricevalsales) {
              refine({
                min: minpricevalsales,
              })
            } else refine(e.value, e.label)
          } else {
            refine({
              min: minpricevalsales,
              max: e.value,
            })
          }
        }}
        styles={customStylesPrice}
        components={{ IndicatorSeparator: () => null }}
      />
    </div>
  )
}

const CustommaxpriceSelectboxSales = connectRange(maxpriceSelectBoxSales)
// Property Sale Max Price

// Property Rentals Min Price
const priceminRangeRentals = [
  {
    value: "0",
    label: "No Min"
  },
  {
    value: "1000",
    label: "£1,000 pcm"
  },
  {
    value: "2000",
    label: "£2,000 pcm"
  },
  {
    value: "3000",
    label: "£3,000 pcm"
  },
  {
    value: "4000",
    label: "£4,000 pcm"
  },
  {
    value: "5000",
    label: "£5,000 pcm"
  },
  {
    value: "6000",
    label: "£6,000 pcm"
  }
]

const minpriceSelectBoxRentals = ({
  currentRefinement,
  min,
  max,
  precision,
  refine,
}) => {
  let minPriceRangeRentals = priceminRangeRentals;
  if (currentRefinement.max !== undefined && currentRefinement.max != "0") {
    minPriceRangeRentals = priceminRangeRentals.filter((x) => parseInt(x.value) < parseInt(currentRefinement.max))
  }

  return (
    <div className="select-group">
      <Select
        name="price"
        options={minPriceRangeRentals}
        defaultValue={currentRefinement.min || "0"}
        placeholder={currentRefinement.min === undefined || null || 0 ? "Min Price" : "£" + currentRefinement.min.toLocaleString() + " PCM"}
        classNamePrefix={"select-opt"}
        isSearchable={false}
        // onChange={(e) => {
        //     minpricevalrentals = e.value
        //     if (e.value === "0") {
        //         if (maxpricevalrentals) {
        //             refine({
        //                 max: maxpricevalrentals,
        //             })
        //         } else refine(e.value, e.label)
        //     } else {
        //         refine({
        //             min: e.value,
        //             max: maxpricevalrentals,
        //         })
        //     }
        // }}
        onChange={(e) => {
          minpricevalrentals = e.value
          if (e.value === "0") {
            if (maxpricevalrentals !== "0") {
              refine({
                max: maxpricevalrentals,
              })
            } else refine(e.value, e.label)
          } else {
            if (maxpricevalrentals == "0") {
              refine({
                min: e.value,
                // max: maxpricevalrentals,
              })
            } else {
              refine({
                min: e.value,
                max: maxpricevalrentals,
              })
            }
          }
        }}
        styles={customStylesPrice}
        components={{ IndicatorSeparator: () => null }}
      />
    </div>
  )
}

const CustomminpriceSelectboxRentals = connectRange(minpriceSelectBoxRentals)
// Property Rentals Min Price

// Property Rentals Max Price
const pricemaxRangeRentals = [
  {
    value: "0",
    label: "No Max"
  },
  {
    value: "6000",
    label: "£6,000 pcm +"
  },
  {
    value: "5000",
    label: "£5,000 pcm"
  },
  {
    value: "4000",
    label: "£4,000 pcm"
  },
  {
    value: "3000",
    label: "£3,000 pcm"
  },
  {
    value: "2000",
    label: "£2,000 pcm"
  },
  {
    value: "1000",
    label: "£1,000 pcm"
  }
]

const maxpriceSelectBoxRentals = ({
  currentRefinement,
  min,
  max,
  precision,
  refine,
}) => {

  let maxPriceRangeRentals = pricemaxRangeRentals;
  let maxpricedisablerentals = ''
  if (currentRefinement.min !== undefined) {
    maxPriceRangeRentals = pricemaxRangeRentals.filter(x => x.value == "0" || parseInt(x.value) > parseInt(currentRefinement.min))
  }
  if (currentRefinement.min == "10000000") {
    maxpricedisablerentals = "disabled"
  }

  return (
    <div className="select-group">
      <Select
        name="price"
        options={maxPriceRangeRentals}
        defaultValue={currentRefinement.max || "0"}
        placeholder={currentRefinement.max === undefined || null || 0 ? "Max Price" : "£" + currentRefinement.max.toLocaleString() + " PCM"}
        classNamePrefix={"select-opt"}
        isSearchable={false}
        onChange={(e) => {
          maxpricevalrentals = e.value
          if (e.value === "0") {
            if (minpricevalrentals) {
              refine({
                min: minpricevalrentals,
              })
            } else refine(e.value, e.label)
          } else {
            refine({
              min: minpricevalrentals,
              max: e.value,
            })
          }
        }}
        styles={customStylesPrice}
        components={{ IndicatorSeparator: () => null }}
      />
    </div>
  )
}

const CustommaxpriceSelectboxRentals = connectRange(maxpriceSelectBoxRentals)
// Property Rentals Max Price

// Property price Sales
const PropertyPriceSales = () => {
  return (
    <>
      <CustomminpriceSelectboxSales attribute="price" />
      <CustommaxpriceSelectboxSales attribute="price" />
    </>
  )
}
// Property price Sales

// Property price Rentals
const PropertyPriceRentals = () => {
  return (
    <>
      <CustomminpriceSelectboxRentals attribute="price" />
      <CustommaxpriceSelectboxRentals attribute="price" />
    </>
  )
}
// Property price Rentals

// Bedrooms
const bedroomSelectBox = ({
  currentRefinement,
  min,
  max,
  precision,
  refine,
}) => {

  let bedroomvalselect = ""
  if (currentRefinement.max !== undefined) {
    bedroomvalselect = 0
  } else if (currentRefinement.min !== undefined) {
    bedroomvalselect = currentRefinement.min
  }

  return (
    <Select
      name="beds"
      options={[
        { value: "", label: "Any" },
        { value: '1', label: '1 +' },
        { value: '2', label: '2 +' },
        { value: '3', label: '3 +' },
        { value: '4', label: '4 +' },
        { value: '5', label: '5 +' }
      ]}
      placeholder="Beds"
      classNamePrefix={"select-opt"}
      styles={customStyles}
      onChange={(e) => {
        if (e.value === "") {
          refine(e.value, e.label)
        } else if (e.value === "0") {
          refine({
            max: e.value,
          })
        } else {
          refine({
            min: e.value,
          })
        }
      }}
      isSearchable={false}
      components={{ DropdownIndicator: () => null }}
    />
  )
}

const CustombedroomSelectbox = connectRange(bedroomSelectBox)
// Bedrooms

// Property type
const buildingSelectbox = ({ items, currentRefinement, refine }) => (
  <Select
    name="building"
    options={[
      { value: "", label: "All Properties" },
      { value: "apartment", label: "Apartments" },
      { value: "house", label: "Houses" },
      { value: "bungalow", label: "Bungalows" }
    ]}
    placeholder="Type"
    classNamePrefix={"select-opt"}
    onChange={(e) => { refine(e.value, e.label) }}
    isSearchable={false}
    components={{ DropdownIndicator: () => null }}
    styles={customStyles}
  />
)

const CustombuildingSelectbox = connectMenu(buildingSelectbox)
// Property type

// No Results
const NoStats = ({ processingTimeMS, nbHits }) => {
  return (
    <>
      {nbHits === 0 &&
        <div className="no-result text-center mb-5">
          <h4>Unfortunately, we do not currently have any properties that match your search criteria.</h4>
        </div>
      }
    </>
  )
}

const CustomNoStats = connectStats(NoStats)
// No Results

// Results count
const Stats = ({ processingTimeMS, nbHits }) => <>{nbHits}</>

const CustomStats = connectStats(Stats)
// Results count

// Custom sortby
const CustomSortBy = ({ items, refine, currentRefinement }) => (
  <div className="search-select-box">
    <Select
      options={items}
      defaultValue={currentRefinement || ''}
      placeholder="Highest Price"
      classNamePrefix={"select-opt"}
      isSearchable={false}
      onChange={(e) => { refine(e.value, e.label) }}
      styles={customStyles}
      components={{ IndicatorSeparator: () => null }}
    />
  </div>
);

const CustomSortByFilter = connectSortBy(CustomSortBy);
// Custom sortby

// Create URL
export const createURL = (props, state, location) => {
  let myarea = state.menu
 
  const isDefaultRoute =
    !state.query &&
    !state.SortBy &&
    state.page === 1 &&
    state.menu &&
    state.range &&
    !state.range.price &&
    !state.range.bedroom

  if (isDefaultRoute) {
    return ""
  }

  var areaPath = "in-oxford-and-thame/"
  var bedroomPath = ""
  var pricePath = ""
  var pagePath = ""
  var propertypath = ""
  var propertypath = ""
  var sortPath = ""
  var studentpath = ""


  if (state.query) {
    if (state.query) {
      areaPath = "in-" + encodeURIComponent(decodeURIComponent(state.query)) + "/"
    }
  }

  const queryParameters = {}

  // Property path
  if (state.menu) {
    if (myarea["building"]) {
      propertypath = "type-" + myarea["building"] + "/"
    }
  }
  // Property path
  // student path
  if (props.fullpathname.includes("student-property")) {  
      studentpath = "student-property/" 
  }
  // Property path

  // Bedrooms & Price range path
  if (state.range) {
    // Bedrooms
    if (state.range.hasOwnProperty('bedroom') && state.range.bedroom.max === 0) {
      bedroomPath = "studio/" //queryParameters.price_max = state.range.price.max;
    }
    if (state.range.bedroom) {
      if (state.range.bedroom.min) {
        bedroomPath = state.range.bedroom.min + "-and-more-bedrooms/" //queryParameters.price_max = state.range.price.max;
      }
    }

    // Price
    if (state.range.price) {
      if (state.range.price.min && state.range.price.max) {
        pricePath = "between-" + state.range.price.min + "-and-" + state.range.price.max + '/' //queryParameters.price_min = state.range.price.min;
      } else if (state.range.price.max) {
        pricePath = "under-" + state.range.price.max + '/' //queryParameters.price_max = state.range.price.max;
      } else if (state.range.price.min) {
        pricePath = "over-" + state.range.price.min + '/' //queryParameters.price_max = state.range.price.max;
      }
    }
  }
  // Bedrooms & Price range path

  // Sort path
  if (state.sortBy) {
    if (state.sortBy === index_name + "_price_asc") {
      sortPath = "sortby-price-asc/";
    }
    if (state.sortBy === index_name) {
      sortPath = "sortby-price-desc/";
    }
    if (state.sortBy === index_name + "_most_recent") {
      sortPath = "sortby-most-recent/";
    }
  }
  // Sort path

  // Page path
  if (state.page && state.page !== 1) {
    pagePath = `page-${state.page}/`
  }
  // Page path

  const queryString = qs.stringify(queryParameters, {
    addQueryPrefix: true,
    arrayFormat: "repeat",
  })

  let myUrl = `${areaPath?.toLowerCase()}${studentpath}${propertypath}${bedroomPath}${pricePath}${queryString}${pagePath}${sortPath}`

  if ("/" === myUrl.substr(myUrl.length - 1))
    myUrl = myUrl.substr(0, myUrl.length - 1)

  return `${location}${myUrl}`
}
// Create URL

// URL to searchstate
const searchStateToUrl = (props, searchState, location) =>
  searchState ? `${createURL(props, searchState, location)}` : ""

const urlToSearchState = location => {
  if (location) {
    var query = ""
    let pathUri_main = ''

    let a1 = location.pathname.indexOf("/property/for-sale") > -1
    let a2 = location.pathname.indexOf("/property/to-rent") > -1
    if (a1 == true) {
      pathUri_main = location.pathname.split("/property/for-sale")
    }
    else if (a2 == true) {
      pathUri_main = location.pathname.split("/property/to-rent")
    }
    else {
      pathUri_main = location.pathname.split(location)
    }

    var areaVal = ""
    var bedVal = 10
    var minpriceVal = ""
    var maxpriceVal = ""
    var pageVal = ""
    var propertyval = ""
    var isStudentProperty = false;
    var sortVal = ""
    var sortVal_filt = ""

    if (pathUri_main[1]) {
      // following could be regexp
      let pathUri = pathUri_main[1].split("/")

      //lets loop
      for (let vi = 1; vi <= pathUri.length; vi++) {
        // check for area
        if (typeof pathUri[vi] === "undefined") {
          continue
        }
        // Student type
        if (pathUri[vi].indexOf("student-property") >= 0) {
          isStudentProperty = true;
        }
        // Property type
        if (pathUri[vi].indexOf("type-") >= 0) {
          propertyval = pathUri[vi].replace("type-", "")
        }

        // Area
        if (pathUri[vi].indexOf("in-") >= 0) {
          areaVal = pathUri[vi].replace("in-", "")
        }

        // Price
        if (
          pathUri[vi].indexOf("between-") >= 0 ||
          pathUri[vi].indexOf("over-") >= 0 ||
          pathUri[vi].indexOf("under-") >= 0
        ) {
          let priceFilt1 = pathUri[vi].split("over-")
          if (priceFilt1[1]) {
            minpriceVal = priceFilt1[1]
          }
          let priceFilt2 = pathUri[vi].split("under-")
          if (priceFilt2[1]) {
            maxpriceVal = priceFilt2[1]
          }
          let priceFilt3 = pathUri[vi].split("between-")
          if (priceFilt3[1]) {
            let priceFilt4 = priceFilt3[1].split("-and-")
            minpriceVal = priceFilt4[0]
            maxpriceVal = priceFilt4[1]
          }
        }

        // Bedrooms
        if (pathUri[vi].indexOf("-and-more-") >= 0) {
          bedVal = pathUri[vi].replace("-and-more-bedrooms", "")
        }

        if (pathUri[vi].indexOf("studio") >= 0) {
          // its studio bedroom
          bedVal = 0
        }

        // Sort by
        if (pathUri[vi].indexOf("sortby-") >= 0) {
          sortVal_filt = pathUri[vi].replace("sortby-", "")

          if (sortVal_filt === "price-asc") {
            sortVal = index_name + "_price_asc"
          }

          if (sortVal_filt === "price-desc") {
            sortVal = index_name
          }

          if (sortVal_filt === "most-recent") {
            sortVal = index_name + "_most_recent"
          }
        }

        // Page
        if (pathUri[vi].indexOf("page") >= 0) {
          pageVal = pathUri[vi].replace("page-", "")
        }
      }
    }
  }

  // Property type
  if (propertyval) {
    query += `&menu[building]=` + propertyval
  }

  // if (isStudentProperty) {
  //   query += `&menu[studentProperty]=` + 1
  // }

  // Area
  // if (areaVal) {
  //   areaVal = areaVal.toLowerCase();
  //   if (areaVal == "oxford") query += `&query=`
  //   else query += `&query=` + areaVal
  // }
  if (areaVal) {
    areaVal = areaVal.toLowerCase();
    if (areaVal.length < 4) {
      areaVal = '"' + areaVal + '"'
    }
    if (areaVal == "oxford-and-thame") query += `&query=`
    else query += `&query=` + areaVal
  }

  // Price
  if (minpriceVal) {
    query += `&range[price][min]=` + minpriceVal
  }

  if (maxpriceVal) {
    query += `&range[price][max]=` + maxpriceVal
  }

  // Bedrooms
  if (bedVal == 0) {
    query += `&range[bedroom][min]=` + 0
  } else if (bedVal < 10) {
    query += `&range[bedroom][min]=` + bedVal
  }

  // Page
  if (pageVal) {
    query += `&page=${pageVal}`
  }

  // Sort by
  if (sortVal) {
    query += `&sortBy=` + sortVal
  }

  return qs.parse(query)
}
// URL to searchstate

class PropertySearch extends React.Component {

  constructor(props) {
    super(props);
  }

  state = {
    searchState: urlToSearchState(typeof window !== 'undefined' ? window.location : ''),
    priceDropdown: false,
    priceDropdownMobile: false,
    moreDropdown: false,
    mobileRefineFilter: false,
    searchText: false,
    includeSoldinside: true,
    includeLetinside: true
    // userObjects:{}
  }

  // Price dropdown
  priceDropdown = (e) => {
    this.setState({ priceDropdown: !this.state.priceDropdown })
    this.setState({ moreDropdown: false })
  }

  priceDropdownMobile = (e) => {
    this.setState({ priceDropdownMobile: !this.state.priceDropdownMobile })
  }
  // price dropdown

  // More dropdown
  moreDropdown = (e) => {
    this.setState({ moreDropdown: !this.state.moreDropdown })
    this.setState({ priceDropdown: false })
  }
  // More dropdown

  // Close dropdown
  closeDropdown = (e) => {
    this.setState({ priceDropdown: false })
    this.setState({ moreDropdown: false })
  }
  // Close dropdown

  // Mobile refine filter
  mobileRefineFilter = (e) => {
    this.setState({ mobileRefineFilter: !this.state.mobileRefineFilter })
  }
  // Mobile refine filter

  // Search text
  searchText = (e) => {
    this.setState({ searchText: !this.state.searchText })
  }
  // Search text

  // Sale View
  saleView = (e) => {

    navigate(`/property/for-sale/in-oxford-and-thame/`)
  }
  // Sale view



  // Rent View
  rentView = (e) => {
    navigate(`/property/to-rent/in-oxford-and-thame/`)
  }
  // Rent View
  // Sale View
  studentPage = (student) => {
    if (student) {
      window.location.href = `/property/to-rent/in-oxford-and-thame/`
    } else {
      window.location.href = `/property/to-rent/in-oxford-and-thame/student-property/`
    }

  }
  // Sale view
  // List View
  listView = (e) => {
    sessionStorage.setItem('tabType', 'list')
    // navigate("/property/" + this.props.ptypetag + "/in-oxford-and-thame")
    navigate(this.props.fullpathone.pathname.replace("/property-map/", "/property/"))
  }
  // List View

  // Map View
  mapView = (e) => {
    sessionStorage.setItem('tabType', 'map')
    // navigate("/property-map/" + this.props.ptypetag + "/in-oxford-and-thame")
    navigate(this.props.fullpathone.pathname.replace("/property/", "/property-map/"))
  }
  // Map View

  componentDidUpdate(prevProps) {
    if (prevProps.location !== this.props.location) {
      this.setState({ searchState: urlToSearchState(this.props.location) })
    }
  }

  onSearchStateChange = searchState => {
    clearTimeout(this.debouncedSetState)
    this.debouncedSetState = setTimeout(() => {
      navigate(searchStateToUrl(this.props, searchState, this.props.locationname), searchState)
    }, updateAfter)
    this.setState({ searchState })
  }

  includeSoldclick = e => {
    this.setState({
      includeSoldinside: !this.state.includeSoldinside
    })
  }

  includeLetclick = e => {
    this.setState({
      includeLetinside: !this.state.includeLetinside
    })
  }

  // onSearchStateChange2 = (searchState) => {
  //   this.setState({ searchState })
  // }

  componentDidMount() {

    if (sessionStorage.getItem('searchindex') != null) {
      // if(sessionStorage.getItem('tabView') != null && sessionStorage.getItem('tabView') === 'mapview'){
      // $(".results-view").addClass("map-veiw-content");
      // }

      var idelement = "item" + sessionStorage.getItem('searchindex');
      setTimeout(function () {
        var elmnt = document.getElementById(idelement.toString());
        if (elmnt) {
          elmnt.scrollIntoView();
          sessionStorage.removeItem('searchindex')
        }
      }, 1);
    }
    else {
      // load on top
      $(document).ready(function () {
        $("html, body").scrollTop(0)
      });
      // load on top
    }

    $(document).mouseup(function (e) {
      var container = $(".search-dropdown");

      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $(".search-dropdown").removeClass("active-tab")
        $(".property-filter-search").removeClass("active-filter")
      }
    });

    // if (isAuthenticated) {
    //   const getUserObjects = async () => {
    //       try {
    //           const userObjects = await getUserobjectData()
    //           this.setState({
    //             userObjects: userObjects.data.data
    //           })
    //           // setUserObjects(userObjects.data.data)
    //       } catch (e) {
    //           console.log("e:", e)
    //       }
    //   }
    //   getUserObjects()
    // }
  }

  render() {
    // 
    const capitalize = (s) => {
      if (typeof s !== 'string') return ''
      return s.charAt(0).toUpperCase() + s.slice(1)
    }

    const searchParams = parseSearchUrl(this.props.ptype, this.props.fullpathname);

    let saveSearchParams = savedSearchParams(searchParams);
    // console.log("saveSearchParams => ", saveSearchParams);
    if ((saveSearchParams?.areas || '') === 'oxford and-thame') {
      saveSearchParams.areas = 'oxford and thame';
    }
    console.log("saveSearchParams => ", saveSearchParams, searchParams);

    const h1 = propertyH1(searchParams);

    const areaName = searchParams.areas;

    const pType = searchParams.pType;

    let propertyType = "";
    if (searchParams.type == "") {
      propertyType = "property"
    } else {
      propertyType = searchParams.type
    }

    const actionStr = ACTION_TYPES[pType];
    const actionDescStr = ACTION_DESC_TYPES[pType];

    var description = `Looking for ${capitalize(propertyType)}${actionStr}${capitalize(searchParams.areas.replace(/-/g, ' ').replace('thame', 'Thame'))}. Contact our property experts and get help to find ${capitalize(propertyType)}${actionStr}${capitalize(searchParams.areas.replace(/-/g, ' ').replace('thame', 'Thame'))}`
    if (searchParams.type) {
      description = `Discover ${capitalize(propertyType)}${actionStr}${capitalize(searchParams.areas.replace(/-/g, ' ').replace('thame', 'Thame'))} here. Book an appointment with one of our specialists today to find the perfect ${capitalize(propertyType)}${actionStr}anywhere in ${capitalize(searchParams.areas.replace(/-/g, ' ').replace('thame', 'Thame'))}.`
    }
    if (searchParams.price.min || searchParams.price.max) {
      description = `Find the wide range of ${capitalize(propertyType)}${actionStr}${capitalize(searchParams.areas.replace(/-/g, ' ').replace('thame', 'Thame'))} with College and County. Book an appointment with one of our specialists today.`
    }
    if (searchParams.bedrooms) {
      description = `Check here for latest collection of ${searchParams.bedrooms} bedroom ${capitalize(propertyType)}${actionStr}${searchParams.areas.replace(/-/g, ' ')}. College and County offers a wide range of ${capitalize(propertyType)}${actionStr}${capitalize(searchParams.areas.replace(/-/g, ' ').replace('thame', 'Thame'))}.`
    }
    if ((searchParams.price.min || searchParams.price.max) && searchParams.type) {
      description = `Find beautiful collections of ${capitalize(propertyType)}${actionStr}${capitalize(searchParams.areas.replace(/-/g, ' ').replace('thame', 'Thame'))} for you. Contact College and County, the leading estate agents and letting agents in the ${capitalize(searchParams.areas.replace(/-/g, ' ').replace('thame', 'Thame'))} today.`
    }
    if ((searchParams.price.min || searchParams.price.max) && searchParams.bedrooms) {
      description = `Discover ${searchParams.bedrooms} bedroom ${capitalize(propertyType)}${actionStr}${capitalize(searchParams.areas.replace(/-/g, ' ').replace('thame', 'Thame'))} with College and County,  Book a free property valuation with us for accurate property valuations today.`
    }
    if (searchParams.type && searchParams.bedrooms) {
      description = `Look into the best ${searchParams.bedrooms} bedroom ${capitalize(propertyType)}${actionStr}${capitalize(searchParams.areas.replace(/-/g, ' ').replace('thame', 'Thame'))}, Contact College and County leading estate agents and letting agents in ${capitalize(searchParams.areas.replace(/-/g, ' ').replace('thame', 'Thame'))}.`
    }
    if ((searchParams.price.min || searchParams.price.max) && searchParams.type && searchParams.bedrooms) {
      description = `Find the latest ${searchParams.bedrooms} bedroom ${capitalize(propertyType)}${actionStr}${capitalize(searchParams.areas.replace(/-/g, ' ').replace('thame', 'Thame'))} ${searchParams.price.min} ${searchParams.price.max} with College and County, our experts help you find the perfect ${capitalize(propertyType)}${actionStr}${capitalize(searchParams.areas.replace(/-/g, ' ').replace('thame', 'Thame'))}.`
    }

    const isPageLoadBg = (typeof this.props.fullpathname === "undefined");
    // 


    var defaultStatus = this.state.includeSoldinside ? ['For Sale', 'New Instruction', 'Under Offer', "Sold"] : ['For Sale', 'New Instruction', 'Under Offer'];
    let studentFilter = ''

    if (this.props.ptype === "lettings") {
      defaultStatus = this.state.includeLetinside ? ["To Let", "Let", "Let Agreed"] : ["To Let", "Let Agreed"];
      if (searchParams.extra.isStudentProperty) {
        studentFilter = 'AND (office_crm_id:"STUDENT" OR office_crm_id:"POSTGRAD")'
      } else {
        studentFilter = 'AND NOT office_crm_id:"STUDENT" AND NOT office_crm_id:"POSTGRAD"'
      }
    }

    let mystatus = ''
    if (defaultStatus) {
      if (Array.isArray(defaultStatus)) {
        mystatus = '(status:"' + (defaultStatus).join('" OR status:"') + '")'
      } else {
        mystatus = '(status:"' + (defaultStatus) + '")'
      }
    } 

    return (
      <React.Fragment>
        <UserObjectStoreProvider>
          {!isPageLoadBg &&
            <SeoResults title={h1} searchParams={searchParams} description={description} location={this.props.fullpathname} pcategorytype={this.props.pcategorytype} />
          }
          <div className="page-head-search"><Header /></div>
          {/* <div className="filtersearchsold">
                  <IncludeSold searchState={this.state.searchState}
                    searchClient={searchClient}
                    indexName={index_name}
                    createURL={createURL}
                    onSearchStateChange={this.onSearchStateChange2}
                  />
                </div> */}
          <InstantSearch
            indexName={index_name}
            searchClient={searchClient}
            searchState={this.state.searchState}
            onSearchStateChange={this.onSearchStateChange}
            createURL={createURL}
            routing="true"
          >
            <Configure filters={`publish:true AND searchType:${this.props.ptype} AND department:${this.props.pcategorytype} AND ${mystatus} ${studentFilter}`}
              hitsPerPage={12}
            />
            {/* <div className="d-none">
            <RefinementList
              attribute="searchType"
              defaultRefinement={[this.props.ptype]}
            />
            <RefinementList
              attribute="department"
              defaultRefinement={[this.props.pcategorytype]}
            />
            <RefinementList
              attribute="status"
              defaultRefinement={[this.props.pstatustype]}
            />
            <RefinementList
              attribute="publish"
              defaultRefinement={["true"]}
            />
          </div> */}

            <section className="search-banner">
              <Container>
                <Row>
                  <Col lg={12}>
                    <ScrollAnimation animateOnce={true} animateIn="fadeInUp"><h3><span className="break-text">Find your</span> <span className="stroke-text">next home</span> today.</h3></ScrollAnimation>
                  </Col>
                </Row>
                <ScrollAnimation animateOnce={true} animateIn="fadeInUp">

                  <div className={this.state.mobileRefineFilter ? "search-filter-block open-filter" : "search-filter-block"}>
                    <div className="filter-head" onClick={() => this.mobileRefineFilter()}>
                      <span>Refine Your Search</span>
                      <i className={this.state.mobileRefineFilter ? "icon-filter-angle-up" : "icon-filter-angle-up icon-filter-angle-down"}></i>
                    </div>
                    <div className="filter-content">
                      <Form>
                        <Tab.Container defaultActiveKey={this.props.ptype === "sales" ? "buy-tab" : "rent-tab"}>
                          <Row>
                            <Col md={3} lg={2} className="pr-custom-md col-grid-button">
                              <div className="">
                                <Nav variant="pills" className="filter-button-group">
                                  <Nav.Link eventKey="buy-tab" onClick={this.saleView} className="btn btn-outline">Buy</Nav.Link>
                                  <Nav.Link eventKey="rent-tab" onClick={this.rentView} className="btn btn-outline">Rent</Nav.Link>
                                </Nav>
                              </div>
                            </Col>
                            <Col md={9} lg={3} className="col-grid-form">
                              <SearchBox />
                            </Col>
                            <Col lg={7} className="col-grid-button-groups">
                              <div className="filter-btn-group-right">
                                {this.props.ptype == "lettings" &&
                                  <div className=" d-md-block d-none mb-3 mb-md-0 custom-selectbox student-properties">
                                    {searchParams.extra.isStudentProperty ?
                                      <Button type="button" onClick={() => { this.studentPage(searchParams.extra.isStudentProperty) }} className="btn btn-outline">Professional Properties</Button>
                                      :
                                      <Button type="button" onClick={() => { this.studentPage(searchParams.extra.isStudentProperty) }} className="btn btn-outline">HMO Properties</Button>
                                    }
                                  </div>
                                }
                                <div className={this.state.priceDropdown ? "search-dropdown price-dropdown active-tab d-md-block d-none" : "search-dropdown price-dropdown d-md-block d-none"}>
                                  <Button type="button" variant="outline" className="d-md-block mb-3 mb-md-0 price-dropdown price-range-btn" onClick={() => this.priceDropdown()}>Price Range</Button>
                                  <div className={this.state.priceDropdown ? "property-filter-search price-dropdown-filter active-filter" : "property-filter-search price-dropdown-filter"}>
                                    {this.props.ptype === "sales" ? <PropertyPriceSales /> : <PropertyPriceRentals />}
                                  </div>
                                </div>
                                <div className="d-md-block d-none mb-3 mb-md-0 custom-selectbox" onClick={() => this.closeDropdown()}>
                                  <CustombedroomSelectbox attribute="bedroom" />
                                </div>
                                <div className="d-md-block d-none mb-3 mb-md-0 custom-selectbox property-type" onClick={() => this.closeDropdown()}>
                                  <CustombuildingSelectbox attribute="building" />
                                </div>
                                <div className={this.state.moreDropdown ? "search-dropdown more-dropdown active-tab d-md-block d-none" : "search-dropdown more-dropdown d-md-block d-none"}>
                                  <Button type="button" variant="outline" className="d-lg-block more-filter-btn" onClick={() => this.moreDropdown()}><i class="icon-more-btn"></i> More</Button>
                                  <div className={this.state.moreDropdown ? "property-filter-search more-dropdown-filter active-filter" : "property-filter-search more-dropdown-filter"}>
                                    {
                                      this.props.ptype === "sales" ?
                                        <div className="property-filter_check">
                                          {/* <ToggleRefinement
                                          attribute="status"
                                          label="Include Sold"
                                          value={['Sold']}
                                          defaultRefinement={['Sold']}
                                        /> */}
                                          <div className="switch-button ">
                                            <label for="toggle-button">
                                              <input onChange={this.includeSoldclick}
                                                type="checkbox" id="toggle-button"
                                                checked={this.state.includeSoldinside ? "checked" : ""} />
                                              <span className="toggle-switch">
                                                <span className="toggle-switch-bar"></span>
                                              </span>
                                              <span className="toggle-text pl-2">Include Sold</span>
                                            </label>
                                          </div>
                                          {/* <div className="d-none">
                                          <ToggleRefinement
                                            attribute="status"
                                            label="Under Offer"
                                            value={['Under Offer']}
                                            defaultRefinement={['Under Offer']}
                                          />
                                        </div>
                                        <div className="d-none">
                                          <ToggleRefinement
                                            attribute="status"
                                            label="New Instruction"
                                            value={['New Instruction']}
                                            defaultRefinement={['New Instruction']}
                                          />
                                        </div> */}
                                        </div>
                                        :
                                        <div className="property-filter_check">
                                          <div className="switch-button ">
                                            <label for="toggle-button">
                                              <input onChange={this.includeLetclick}
                                                type="checkbox" id="toggle-button"
                                                checked={this.state.includeLetinside ? "checked" : ""} />
                                              <span className="toggle-switch">
                                                <span className="toggle-switch-bar"></span>
                                              </span>
                                              <span className="toggle-text pl-2">Include Let</span>
                                            </label>
                                          </div>
                                          {/* <ToggleRefinement
                                            attribute="status"
                                            label="Include Let"
                                            value={['Let']}
                                            defaultRefinement={['Let']}
                                          />
                                          <div className="d-none">
                                            <ToggleRefinement
                                              attribute="status"
                                              label="Let Agreed"
                                              value={['Let Agreed']}
                                              defaultRefinement={['Let Agreed']}
                                            />
                                          </div> */}
                                        </div>
                                    }

                                    {this.props.ptype === "sales" ?
                                      <a href="/property/for-sale/in-oxford-and-thame/" variant="outline" className="d-md-none d-lg-block mb-3 mb-md-0 price-dropdown d-none clear-btn clear-filter-text">Clear Filter</a>
                                      :
                                      <a href="/property/to-rent/in-oxford-and-thame/" variant="outline" className="d-md-none d-lg-block mb-3 mb-md-0 price-dropdown d-none clear-btn clear-filter-text">Clear Filter</a>
                                    }
                                  </div>
                                </div>
                                {/* {this.props.ptype === "sales" ?
                                                    <a href="/property/for-sale/in-oxford/" variant="outline" className="d-md-none d-lg-block mb-3 mb-md-0 price-dropdown d-none clear-btn">Clear</a>
                                                    :
                                                    <a href="/property/to-rent/in-oxford/" variant="outline" className="d-md-none d-lg-block mb-3 mb-md-0 price-dropdown d-none clear-btn">Clear</a>
                                                        } */}
                                <div className="mobile-refine-filter d-md-none d-block">
                                  <div className={this.state.moreDropdown ? "search-dropdown more-dropdown active-tab" : "search-dropdown more-dropdown"}>
                                    <Button type="button" variant="outline" className="d-md-none d-lg-block" onClick={() => this.moreDropdown()}><i class="icon-more-btn"></i> More</Button>
                                    <div className={this.state.moreDropdown ? "property-filter-search more-dropdown-filter active-filter" : "property-filter-search more-dropdown-filter"}>
                                      {this.props.ptype == "lettings" &&
                                        <div className="d-md-block mb-3 mb-md-0 custom-selectbox mob-student-property">
                                          {searchParams.extra.isStudentProperty ?
                                            <Button type="button" onClick={() => { this.studentPage(searchParams.extra.isStudentProperty) }} className="btn btn-outline">Professional Properties</Button>
                                            :
                                            <Button type="button" onClick={() => { this.studentPage(searchParams.extra.isStudentProperty) }} className="btn btn-outline">HMO Properties</Button>
                                          }

                                        </div>
                                      }
                                      <div className={this.state.priceDropdownMobile ? "search-dropdown price-dropdown active-tab mobile-price-tab" : "search-dropdown price-dropdown mobile-price-tab"}>
                                        <Button type="button" variant="outline" className="d-md-block mb-3 mb-md-0 price-dropdown" onClick={() => this.priceDropdownMobile()}>Price Range</Button>
                                        <div className={this.state.priceDropdownMobile ? "property-filter-search price-dropdown-filter active-filter" : "property-filter-search price-dropdown-filter"}>
                                          {
                                            this.props.ptype === "sales" ?
                                              <div className="custom-selectbox">
                                                <PropertyPriceSales />
                                              </div>
                                              :
                                              <div className="custom-selectbox">
                                                <PropertyPriceRentals />
                                              </div>
                                          }
                                        </div>
                                      </div>
                                      <div className="d-md-block mb-3 mb-md-0 custom-selectbox">
                                        <CustombedroomSelectbox attribute="bedroom" />
                                      </div>
                                      <div className="d-md-block mb-3 mb-md-0 custom-selectbox">
                                        <CustombuildingSelectbox attribute="building" />
                                      </div>
                                      {
                                        this.props.ptype === "sales" ?
                                          <div className="property-filter_check">
                                            {/* <ToggleRefinement
                                              attribute="status"
                                              label="Include Sold"
                                              value={['Sold']}
                                              defaultRefinement={['Sold']}
                                            />
                                            <div className="d-none">
                                              <ToggleRefinement
                                                attribute="status"
                                                label="Under Offer"
                                                value={['Under Offer']}
                                                defaultRefinement={['Under Offer']}
                                              />
                                            </div> */}
                                            <div className="switch-button ">
                                              <label for="toggle-button">
                                                <input onChange={this.includeSoldclick}
                                                  type="checkbox" id="toggle-button"
                                                  checked={this.state.includeSoldinside ? "checked" : ""} />
                                                <span className="toggle-switch">
                                                  <span className="toggle-switch-bar"></span>
                                                </span>
                                                <span className="toggle-text pl-2">Include Sold</span>
                                              </label>
                                            </div>
                                          </div>
                                          :
                                          <div className="property-filter_check">
                                            {/* <ToggleRefinement
                                              attribute="status"
                                              label="Include Let"
                                              value={['Let']}
                                              defaultRefinement={['Let']}
                                            />
                                            <div className="d-none">
                                              <ToggleRefinement
                                                attribute="status"
                                                label="Let Agreed"
                                                value={['Let Agreed']}
                                                defaultRefinement={['Let Agreed']}
                                              />
                                            </div> */}
                                            <div className="switch-button ">
                                              <label for="toggle-button">
                                                <input onChange={this.includeLetclick}
                                                  type="checkbox" id="toggle-button"
                                                  checked={this.state.includeLetinside ? "checked" : ""} />
                                                <span className="toggle-switch">
                                                  <span className="toggle-switch-bar"></span>
                                                </span>
                                                <span className="toggle-text pl-2">Include Let</span>
                                              </label>
                                            </div>
                                          </div>
                                      }

                                      {this.props.ptype === "sales" ?
                                        <a href="/property/for-sale/in-oxford-and-thame/" variant="outline" className="mb-3 mb-md-0 price-dropdown clear-btn clear-filter-text">Clear Filter</a>
                                        :
                                        <a href="/property/to-rent/in-oxford-and-thame/" variant="outline" className="mb-3 mb-md-0 price-dropdown clear-btn clear-filter-text">Clear Filter</a>
                                      }
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </Tab.Container>
                      </Form>
                    </div>
                  </div>
                </ScrollAnimation>
              </Container>
            </section>

            <section className="search-result-list">
              <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                <div className="tab-head">
                  <div className="tab-head-container">
                    <ul className="tab-list">
                      <li onClick={this.listView} className={"active-tab tab-list-item"} >
                        <i className="icon-list-view"></i>List View
                      </li>
                      <li onClick={this.mapView} className={"tab-list-item"}>
                        <i className="icon-map-view"></i>Map View
                      </li>
                    </ul>


                  </div>
                </div>
              </ScrollAnimation>

              <div className={"tab-list active-tablist"}>
                <div className="tab-list-container">
                  <div className="tab-content">
                    <ScrollAnimation animateOnce={true} animateIn="fadeIn" className="pos-relative">
                      <div className={this.state.searchText ? "tab-row-block search-text" : "tab-row-block"}>
                        <h1 className="tab-message">
                          {h1} <span className="text-bold-dark pl-2">(<CustomStats />)</span><i className="icon-info" onClick={() => this.searchText()}></i>
                        </h1>
                        <div className="tab-sub-links">
                          <ul>
                            {/* <li>
                                          <Link href="#">
                                          <i className="icon-wishlist"></i>{" "}
                                          <span className="d-none d-md-block">Save Search</span>
                                          </Link>
                                      </li>
                                      <li>
                                          <Link href="#">
                                          <i className="icon-notification"></i>{" "}
                                          <span className="d-none d-md-block">
                                              Create Alert
                                          </span>
                                          </Link>
                                      </li> */}
                            <li>
                              <SaveItem type="search" searchParams={saveSearchParams} userObjects={this.props.userObjects} loaderEnable={false} >
                                <span className="icon-wrap">
                                  <i class="icon-wishlist icon-default"></i>
                                </span>
                                <span className="icon-text save-text">Save Search</span>
                                <span className="icon-text save-text-search">Save</span>
                                <span className="icon-text saved-text">Saved</span>
                              </SaveItem>
                            </li>
                            <li>
                              <CustomSortByFilter
                                defaultRefinement={index_name}
                                className="search-sory-by"
                                items={[
                                  { value: index_name, label: "Highest Price" },
                                  { value: index_name + "_price_asc", label: "Lowest Price" },
                                ]}
                              />
                            </li>
                          </ul>
                        </div>
                      </div>
                      {
                        this.state.searchText ?
                          <Row className="search-text">
                            <Col lg={7}>
                              {/* <p>Discover a wide range of {h1}, Thame and the surrounding area in London with College and County. Refine your search using the filters below and for more information about {this.props.ptype} property in {capitalize(areaName)}, Thame, Buckingham please contact College and County Estate Agents.</p> */}
                              <p>Discover a wide range of {h1} and the surrounding area in London with College and County. Refine your search using the filters below and for more information about sales property in {capitalize(areaName.replace(/-/g, ' ').replace('thame', 'Thame'))} please contact College and County Estate Agents.</p>
                            </Col>
                          </Row>
                          : ''
                      }
                    </ScrollAnimation>
                    <CustomInfiniteHits location={this.props.fullpathname} userObjects={this.props.userObjects} />
                    <CustomNoStats />
                  </div>
                </div>
              </div>
            </section>
          </InstantSearch>

          <div className="breadcrumb-other-page">
            <section className="breadcrumb-section">
              <Container>
                <Breadcrumb>
                  <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                  <Breadcrumb.Item active>{searchParams.pType === "sales" ? "Sale" : searchParams.pType === "lettings" ? "Rent" : ""}</Breadcrumb.Item>
                </Breadcrumb>
              </Container>
            </section>
          </div>
          {/* {JSON.stringify(searchParams)} */}
          <Footer
            resultlabel={searchParams.pType} searchtype={searchParams.pType} searchBedroomfield={searchParams.bedrooms} searchPtype={searchParams.type} Searcharea={searchParams}
          />
        </UserObjectStoreProvider>
      </React.Fragment>
    )
  }
}

export default PropertySearch
